/*
  Adventskalender-Band — sections/adventskalender-band.liquid

  Bedient AUSSCHLIESSLICH die beiden Pfeile. Die Türchen selbst sind
  `<details>`: Öffnen, Schließen, Tastatur und Screenreader-Semantik macht der
  Browser. Fällt diese Datei aus, bleibt das Band vollständig benutzbar —
  gewischt und getabbt wird weiterhin, nur die Pfeile bleiben unsichtbar.

  Deshalb stehen die Knöpfe im Markup auf `disabled` und ihr Container ohne
  `is-aktiv`: sichtbar werden sie erst hier, und nur solange die Bahn wirklich
  überläuft. Ein Knopf, der nichts tut, ist schlimmer als kein Knopf.

  Handgeschrieben wie assets/quick-order-list.js — nicht Teil des
  Webpack-Bundles, daher kein `dynamic-import`, sondern ein normales
  <script defer>.
*/

class AdventBand extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-advent-viewport]');
    this.nav = this.querySelector('[data-advent-nav]');
    this.prev = this.querySelector('[data-advent-nav-button="prev"]');
    this.next = this.querySelector('[data-advent-nav-button="next"]');

    if (!this.viewport || !this.nav) return;

    this.onScroll = this.onScroll.bind(this);
    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

    this.prev.addEventListener('click', () => this.step(-1));
    this.next.addEventListener('click', () => this.step(1));

    // Die Bahn wächst nicht nur beim Fensterwechsel: Schriften laden nach und
    // ein aufschwingendes Türchen ändert nichts an der Breite, aber der
    // Theme-Editor tauscht Türchen im laufenden Betrieb aus.
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.viewport);

    this.update();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.viewport) this.viewport.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.update();
    });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
    // Teilpixel: bei 100 % Zoom geht die Rechnung auf, bei 90 % fehlt sonst
    // ein halbes Pixel und der Weiter-Knopf bleibt am Ende aktiv.
    const laeuftUeber = scrollWidth - clientWidth > 1;

    this.nav.classList.toggle('is-aktiv', laeuftUeber);

    this.prev.disabled = !laeuftUeber || scrollLeft <= 1;
    this.next.disabled = !laeuftUeber || Math.ceil(scrollLeft + clientWidth) >= scrollWidth - 1;
  }

  // Eine Schrittweite ist ein Türchen-Abstand, nicht eine Bildschirmbreite:
  // die Türchen liegen auf einer Welle, und seitenweises Springen zerreißt sie.
  //
  // Gemessen an der Bahn, NICHT aus --advent-step gelesen: die Variable steht
  // in rem, und getPropertyValue liefert das Token unverändert ("11.625rem")
  // statt eines Pixelwerts. parseFloat hätte daraus 11.625 Pixel gemacht.
  schrittweite() {
    const track = this.viewport.firstElementChild;
    const span = parseFloat(getComputedStyle(this.viewport).getPropertyValue('--advent-span'));

    if (track && span > 0) return track.offsetWidth / span;
    return this.viewport.clientWidth * 0.8;
  }

  step(richtung) {
    this.viewport.scrollBy({
      left: this.schrittweite() * richtung * 2,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }
}

if (!customElements.get('advent-band')) {
  customElements.define('advent-band', AdventBand);
}
